module.exports = __webpack_public_path__ + "img/2.1b7f10d6.png";